// import Icon from '../components/Icon';
import Typography from '../components/Typography';
import Layout from '../components/Layout';

const AmountLoaded = () => {
  return (
    <div className="bg-[#152C5B] p-6 rounded-[24px]">
      <div className="flex justify-between">
        <Typography weight="bold" className="text-[48px]" color="white">
          $50
        </Typography>
        <ReadyToGiftBadge />
      </div>
      <Typography color="lightblue" className="text-[14px]">
        Loaded by You
      </Typography>
    </div>
  );
};

const ReadyToGiftBadge = ({ className = '' }) => {
  return (
    <div
      className={`backdrop-blur-[2px] bg-[rgba(255,255,255,0.2)] border border-[rgba(255,255,255,0.1)] border-solid content-stretch flex flex-col items-start h-[30px] relative rounded-[9999px] px-3 ${className}`}
      data-name="Overlay+Border+OverlayBlur"
      data-node-id="953:33023"
    >
      <Typography
        weight="semibold"
        className="text-[12px] m-auto"
        color="white"
      >
        Ready to Gift
      </Typography>
    </div>
  );
};

const CircleCheckIcon = ({ size = 80, className = '' }) => {
  // Image asset from Figma (valid for 7 days)
  const imgIcon =
    'https://www.figma.com/api/mcp/asset/4e9848db-b8f3-4c82-8b0a-0f755abc7fff';

  return (
    <div
      className={`bg-[#e8e4f9] content-stretch flex items-center justify-center relative rounded-[9999px] ${className}`}
      style={{ width: `${size}px`, height: `${size}px` }}
      data-name="Background"
      data-node-id="953:33000"
    >
      <div
        className="content-stretch flex flex-col items-start py-[2px] relative shrink-0"
        data-name="Container"
        data-node-id="953:33001"
      >
        <div className="flex items-center justify-center relative shrink-0">
          <div className="-scale-y-100 flex-none">
            <div
              className="relative size-[36px]"
              data-name="Icon"
              data-node-id="953:33002"
            >
              <img
                alt="Check"
                className="block max-w-none size-full"
                src={imgIcon}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const LoadCardConfirmation = () => {
  return (
    <Layout className="pt-7 px-6">
      <CircleCheckIcon className="mb-8 mx-auto" />
      <Typography className="mb-4 text-[24px] text-center" weight="bold">
        Card Loaded!
      </Typography>
      <Typography
        className="mb-10 text-[14px] text-center"
        color="secondary"
        lineHeight="normal"
      >
        This Cauze Card is ready to gift. The recipient will see your video when
        they redeem it.
      </Typography>
      <AmountLoaded />
      <div className="mb-24" />
      <button className="mb-4 cz-btn-brand w-full">Done</button>
      <button className="cz-btn-outline black w-full cursor-pointer py-2">
        Load Another Card
      </button>
    </Layout>
  );
};

export default LoadCardConfirmation;
